export default "__VITE_ASSET__BbBC7znf__"